var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.9976,
    r: 25,
    fill: "#024BD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 30.934H35.8968C35.0901 30.934 34.3925 30.4201 34.2181 29.7736L33.2579 22.5656C32.9649 19.8506 31.1035 17.5364 28.4469 16.5179C28.3172 15.1145 27.064 14.0093 25.5402 14.0093C24.0195 14.0093 22.7666 15.1105 22.6325 16.5101C19.9702 17.4996 18.082 19.7757 17.7518 22.4552L16.8 29.6829C16.6075 30.4201 15.9099 30.934 15.1032 30.934H13.5V35.1405H21.7115C22.0951 36.7806 23.6427 38.0093 25.5 38.0093C27.357 38.0093 28.9046 36.7806 29.2881 35.1405H37.5V30.934ZM35.8258 33.5605H15.1744V32.5092C16.722 32.479 18.053 31.479 18.4439 29.9677L19.4148 22.6414C19.6927 20.3785 21.3882 18.4835 23.7336 17.8159L24.4286 17.6175L24.318 16.9407C24.3086 16.8803 24.2959 16.8198 24.2959 16.7568C24.2959 16.1102 24.8541 15.5845 25.5404 15.5845C26.226 15.5845 26.7852 16.1102 26.7852 16.7568C26.7852 16.8211 26.7711 16.8816 26.7614 16.9434L26.6528 17.6122L27.3377 17.8146C29.6751 18.5072 31.3441 20.4337 31.5935 22.7413L32.5731 30.0584C32.947 31.4803 34.2783 32.479 35.8258 32.5092V33.5605Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.0719e08a.svg";
export { ForwardRef as ReactComponent };